import type {ReactAction} from '@netx/core/bootstrap';
import {faSave} from '@fortawesome/pro-solid-svg-icons';
import {SEARCH_SAVED_ACTION_LABELS} from '../locales';

export const searchSavedActionCreateIcon = faSave;

export type SearchSavedActionCreateParams = Required<Pick<ReactAction, 'cb'>> &
	Partial<Omit<ReactAction, 'cb'>>;

/**
 * Create saved search
 * @param params
 * @returns Action
 */
export const searchSavedActionCreate = (
	params: SearchSavedActionCreateParams,
): ReactAction => ({
	name: 'keyword-gallery-search-saved-create',
	icon: searchSavedActionCreateIcon,
	get label() {
		return SEARCH_SAVED_ACTION_LABELS.CREATE;
	},
	...params,
});

export default searchSavedActionCreate;
